import { useState } from "react";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { useTranslation } from "react-i18next";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";
import TruckSearch from "../../../Components/Inputs/TruckSearch";
import TrailerSearch from "../../../Components/Inputs/TrailerSearch";
import instance from "../../../Interceptor/api_instance";
import { useNavigate } from "react-router-dom";

const ExportReports = ({ close }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    vehicle_type: null,
    vehicle: null,
    start_date: null,
    end_date: null,
    file_type: "xlsx"
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const [carrier, setCarrier] = useState("jfg");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ...filters,
        vehicle_id: filters.vehicle?.value ? filters.vehicle.value : null,
      };
      const res = await instance.post("files/export-maintenance-reports", data);
      if (res.status === 201) {
        navigate("/export-jobs");
      }
    } catch (err) {
      console.error(err);
      setResponseModal({
        message: t("forms.responses.failure"),
        status: t("forms.type.error"),
      });
    } finally {
      setLoading(false);
    }
  };

  const update = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div className="page-mask page-mask-animation">
      {responseModal && (
        <ActionResponse
          message={responseModal.message}
          status={responseModal.status}
          close={() => setResponseModal(null)}
        />
      )}
      <div className="new-modal">
        <h2 className="global-h2 black">{t("general.export-reports")}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-block">
            <label>{t("general.startDate")}</label>
            <div className="input-cont">
              <input
                type="date"
                className="text-input"
                name="start_date"
                onChange={update}
                value={filters.start_date}
              />
            </div>
          </div>
          <div className="form-block">
            <label>{t("general.endDate")}</label>
            <div className="input-cont">
              <input
                type="date"
                className="text-input"
                name="end_date"
                min={filters.start_date}
                onChange={update}
                value={filters.end_date}
              />
            </div>
          </div>
          <div className="form-block">
            <label>Vehicle Type</label>
            <div className="input-cont">
              <fieldset className="fieldsets" name="vehicle_type">
                <div className="input-cont">
                  <div className="radio-options">
                    <input
                      type="radio"
                      className="radio-input"
                      name="vehicle_type"
                      checked={filters.vehicle_type === "truck"}
                      value={"truck"}
                      onChange={update}
                    />
                    <label>{t("yard-tables.table-columns.truck")}</label>
                  </div>
                  <div className="radio-options">
                    <input
                      type="radio"
                      className="radio-input"
                      name="vehicle_type"
                      checked={filters.vehicle_type === "trailer"}
                      value={"trailer"}
                      onChange={update}
                    />
                    <label>{t("yard-tables.table-columns.trailer")}</label>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          {filters.vehicle_type === "truck" && (
            <div>
              <div className="form-block">
                <label>{t("yard-tables.table-columns.carrier")}</label>
                <div className="input-cont">
                  <select
                    className="text-input"
                    name="carrier"
                    value={carrier}
                    onChange={(e) => setCarrier(e.target.value)}
                  >
                    <option value={"jfg"}>JFG</option>
                    <option value={"ati"}>ATI</option>
                  </select>
                </div>
              </div>
              <div className="form-block">
                <label>{t("yard-tables.table-columns.truck")}</label>
                <div className="input-cont">
                  <TruckSearch
                    selectedTruck={filters.vehicle}
                    onSelect={(option) =>
                      setFilters((prev) => ({
                        ...prev,
                        vehicle: option,
                      }))
                    }
                    carrier={carrier}
                    enableAll={true}
                    required={false}
                  />
                </div>
              </div>
            </div>
          )}
          {filters.vehicle_type === "trailer" && (
            <div className="form-block">
              <label>{t("yard-tables.table-columns.trailer")}</label>
              <div className="input-cont">
                <TrailerSearch
                  enableAll={true}
                  required={false}
                  selectedTrailer={filters.vehicle}
                  onSelect={(option) =>
                    setFilters((prev) => ({
                      ...prev,
                      vehicle: option,
                    }))
                  }
                />
              </div>
            </div>
          )}
          <div className="form-block">
            <label>File Type</label>
            <div className="input-cont">
              <select
                className="text-input"
                name="file_type"
                value={filters.file_type}
                onChange={update}
              >
                <option value={"xlsx"}>Excel (.xlsx)</option>
                <option value={"pdf"}>PDF (.pdf)</option>
              </select>
            </div>
          </div>

          <div className="full-cont">
            {loading ? (
              <Spinner />
            ) : (
              <>
                <button className="change-pwd-btn all-btn" type="submit">
                  {t("buttons.submit")}
                </button>
                <button
                  className="cancel-btn all-btn"
                  type="button"
                  onClick={close}
                >
                  {t("buttons.cancel")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExportReports;
